import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LS_SESSION = "s71_session_id";
const LS_TOKEN = "s71_token";
const LS_USER = "s71_user";

export function getSessionId() {
  let id = localStorage.getItem(LS_SESSION);
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(LS_SESSION, id);
  }
  return id;
}

export function getToken() {
  return localStorage.getItem(LS_TOKEN) || null;
}
export function setToken(t) {
  if (t) localStorage.setItem(LS_TOKEN, t);
  else localStorage.removeItem(LS_TOKEN);
}
export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem(LS_USER) || "null");
  } catch {
    return null;
  }
}
export function setStoredUser(u) {
  if (u) localStorage.setItem(LS_USER, JSON.stringify(u));
  else localStorage.removeItem(LS_USER);
}

// owner = logged-in user id, else guest session id
export function getOwner() {
  const u = getStoredUser();
  return u && u.id ? u.id : getSessionId();
}

const http = axios.create({ baseURL: API, timeout: 20000 });
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---- Artist ----
export const apiGetArtist = () => http.get("/artist").then((r) => r.data);
export const apiSaveArtist = (artist) => http.put("/artist", artist).then((r) => r.data);

// ---- Portal ----
export const apiGetPortal = () => http.get("/portal").then((r) => r.data);
export const apiSavePortal = (portal) => http.put("/portal", portal).then((r) => r.data);
export const apiSavePortalSettings = (payload) => http.put("/portal/settings", payload).then((r) => r.data);
export const apiRegistrationStatus = () => http.get("/registration/status").then((r) => r.data);

export const apiUploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return http
    .post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => ({ ...r.data, url: `${BACKEND_URL}${r.data.path}` }));
};

export const apiResolveAudio = (url) =>
  http.get(`/resolve-audio`, { params: { url } }).then((r) => r.data);

// ---- Auth ----
export const apiSignup = (payload) => http.post("/auth/signup", payload).then((r) => r.data);
export const apiLogin = (payload) => http.post("/auth/login", payload).then((r) => r.data);
export const apiMe = () => http.get("/auth/me").then((r) => r.data);
export const apiUpdateProfile = (payload) => http.put("/auth/update", payload).then((r) => r.data);

// ---- Collection / Subscription ----
export const apiGetCollection = (owner) => http.get(`/collection/${owner}`).then((r) => r.data);
export const apiGetSubscription = (owner) => http.get(`/subscription/${owner}`).then((r) => r.data);

// ---- Exclusive ----
export const apiGetExclusive = () => http.get("/exclusive").then((r) => r.data);

// ---- Tickets ----
export const apiGetTickets = (owner) => http.get(`/tickets/${owner}`).then((r) => r.data);

// ---- Support AI ----
export const apiSupportChat = (message) =>
  http.post("/support/chat", { session_id: getSessionId(), message }).then((r) => r.data);

// ---- Payments ----
export const apiStripeCheckout = (body) =>
  http.post("/payments/stripe/checkout", body).then((r) => r.data);
export const apiStripeStatus = (sessionId) =>
  http.get(`/payments/stripe/status/${sessionId}`).then((r) => r.data);
export const apiPaypalCreate = (body) =>
  http.post("/payments/paypal/create", body).then((r) => r.data);
export const apiPaypalCapture = (orderId) =>
  http.post("/payments/paypal/capture", { order_id: orderId }).then((r) => r.data);
